import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { observable } from 'mobx'
import type { JobStatus } from '@/features/jobs/job-status'

export type JobGistProps = ModelProps<JobGist>

/**
 * The gist of a job, only includes the most basic, commonly
 * referenced information needed by other features.
 */
export class JobGist extends Model<JobGist> {
  /**
   * Sentinel none value.
   */
  static readonly none = new JobGist()

  /**
   * Job ID.
   */
  id = Id.none

  /**
   * Short job ID.
   */
  @observable accessor shortId = ''

  /**
   * Workspace that the job is in.
   */
  @observable accessor workspaceId = Id.none

  /**
   * Computed title.
   */
  @observable accessor title = ''

  /**
   * The job status.
   */
  @observable accessor status: JobStatus = 'Unknown'
}

/**
 * The job gist event type.
 */
export type JobGistEvent = Created | Updated

/**
 * A new job was created.
 */
interface Created {
  type: 'Created'
  jobGist: JobGist
}

/**
 * A job was updated.
 */
interface Updated {
  type: 'Updated'
  jobGist: JobGist
}
